import CustomTextField from "components/CustomTextField";
import { Col, Row, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { useParams, useLocation } from "react-router-dom";
import { Modal, Table, Spinner, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  useGetAllAssetsOfUsersQuery,
  useCreateAssetsDetailsMutation,
  useUpdateAssetsDetailsMutation,
} from "./farmerApiSlice";
import { useGetmasterDropdownQuery } from "features/masterdata/MasterApiSlice";
import { useEffect, useState } from "react";
import FarmerNoResponse from "./FarmerNoResponse";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { LoaderDesign } from "./LoaderDesign";
import { Badge } from "antd";
import CardSkeleton from "components/CardSkeleton";
import { Divider } from "@mui/material";

const FarmerDetailsAssets = () => {
  const { id } = useParams();
  const location = useLocation();
  const fullname = location.state?.fullname || "";
  const [AssetsList, setAssetsList] = useState([]);
  const [showError, setError] = useState(false);
  const [createAssets] = useCreateAssetsDetailsMutation();
  const [updateAssets] = useUpdateAssetsDetailsMutation();
  const [disableButton, disableSubmitBtn] = useState(false);
  const [showLoader, setLoader] = useState(false);
  const { data: dropdownData } = useGetmasterDropdownQuery();
  const [dropdownMovableData, setDropdownMovableData] = useState([]);
  const [dropdownImmMovableData, setDropdownImmMovableData] = useState([]);

  const { data: data, isLoading, refetch } = useGetAllAssetsOfUsersQuery(id);
  const [showAddModal, setshowAddModal] = useState(false);
  const [SubmitButtonApi, setSubmitButtonApi] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [Group, editGroup] = useState({
    asset_type: "",
    asset_name: "",
    asset_number: "",
    asset_value: "",
    asset_category: "",
    asset_location: "",
    asset_owner: "",
  });
  useEffect(() => {
    if (dropdownData !== undefined) {
      setDropdownMovableData(dropdownData?.data?.results[0]?.movable_assets);
      setDropdownImmMovableData(
        dropdownData?.data?.results[0]?.immovable_assets
      );
    }
  }, [dropdownData]);
  useEffect(() => {
    const userFromApi = data?.data ? data?.data : AssetsList;
    if (userFromApi !== undefined) setAssetsList(userFromApi);
  }, [data]);

  const AddModal = (updateButtonTag, list) => {
    if (updateButtonTag) {
      setSubmitButtonApi(true);
      setUpdateId(list.id);
    }

    let currentList = {
      asset_type: list.asset_type,
      asset_name: list.asset_name,
      asset_number: list.asset_number,
      asset_value: list.asset_value,
      asset_category: list.asset_category,
      asset_location: list.asset_location,
      asset_owner: list.asset_owner,
    };
    editGroup(currentList);
    setshowAddModal(true);
  };
  const handleClose = () => {
    setshowAddModal(false);
    setError(false);
    setSubmitButtonApi(false);
    setUpdateId("");
    editGroup({
      asset_type: "",
      asset_name: "",
      asset_number: "",
      asset_value: "",
      asset_category: "",
      asset_location: "",
      asset_owner: "",
    });
    disableSubmitBtn(false);
  };
  const onInputChange = (event) => {
    editGroup({
      ...Group,
      [event.target.name]: event.target.value,
    });
  };

  const AddFamilytSubmit = (e) => {
    e.preventDefault();
    disableSubmitBtn(true);

    if (!SubmitButtonApi) {
      createAssets({ id: id, payload: Group })
        .unwrap()
        .then((data) => {
          swal("Assets Created Successfully", {
            buttons: false,
            icon: "success",
            title: "Assets Created Detail",
            timer: 1500,
          });
          setshowAddModal(false);
          disableSubmitBtn(false);
          refetch();
        })
        .catch((error) => {
          toast.error("Error while Creating Member");
          disableSubmitBtn(false);
          return;
        });
    } else {
      updateAssets({ id: updateId, payload: Group })
        .unwrap()
        .then((data) => {
          // toast.success("Assets Updated")
          setshowAddModal(false);
          swal("Assets Updated Successfully", {
            buttons: false,
            icon: "success",
            title: "Assets Updated Detail",
            timer: 1500,
          });
          disableSubmitBtn(false);
          refetch();
        })
        .catch((error) => {
          toast.error("Error while Updating Member");
          disableSubmitBtn(false);
          return;
        });
    }
  };
  const ReloadApplication = () => {
    setLoader(true);
    setTimeout(() => {
      refetch();
      setLoader(false);
    }, 1500);
  };

  return (
    <Card className="globalboxshadow">
      <div
        className="d-flex justify-content-between  align-items-center "
        style={{ borderRadius: "5px",backgroundColor:"#f1f1f1" }}
      >
        <div className="heading-title mt-lg-0 mt-2 py-3">
                <h5
                  className="mx-4"
                  style={{
                    fontSize: "18px",
                    color: "black",
                  }}
                >
                  <i
                    className="mdi mdi-account-hard-hat me-2"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                  {fullname}
                </h5>
              </div>
        <div
          className="d-flex justify-content-end align-items-center flex-wrap"
          style={{ gap: "6px" }}
        >
          <Button
            id="AddDetails99"
            type=""
            className="buttonOrangeDefaultColor"
            onClick={() => AddModal(false, Group)}
            size="sm"
          >
            Add <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
          </Button>
          <Button
            className="bg-transparent text-black fs-6 reloadButton me-2"
            size="sm"
            onClick={ReloadApplication}
          >
           Reload <FontAwesomeIcon icon={faRotateLeft} />
          </Button>
          </div>
      </div>
      {isLoading ? (
        <div className="mt-4">
          <CardSkeleton />
        </div>
      ) : AssetsList.length === 0 ? (
        <FarmerNoResponse />
      ) : (
        <div className=" transparent_card custom_mb">
         
             <div className="">
  {AssetsList &&
    AssetsList.map((fmd, index) => (
      <div className="d-lg-block d-md-none d-none transparent_card custom_mb" key={index}>
              <Divider style={{ borderTop: "2px dotted orange",marginBottom:"5px" }} />
               <div className="p-1 p-lg-3">  
          <div className="row text-gray">
          <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="asset_owner" value={fmd.asset_owner || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="asset_category" value={fmd.asset_category || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="asset_type" value={fmd.asset_type || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="asset_name" value={fmd.asset_name || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="asset_location" value={fmd.asset_location || "N/A"} disabled />
            </div>
            <div className="col-md-1 mb-3">
              <CustomTextField type="text" name="asset_no." value={fmd.asset_number || "N/A"} disabled />
            </div>
            <div className="col-md-1 mb-3">
              <CustomTextField type="text" name="asset_val" value={fmd.asset_value || "N/A"} disabled />
            </div>
           
          
          </div>
          <div className="col-12 text-end p-2 mt-2 mb-0 d-lg-block d-md-none d-none">
                        
                            <Button
                              id="editDetails"
                              type=""
                              className="buttonOrangeDefaultColor"
                              onClick={() => AddModal(true, fmd)}
                              size="sm"
                            >
                              Edit&nbsp; <FontAwesomeIcon icon={faPenToSquare} />
                            </Button>
                         
                        </div>
        </div>
      </div>
    ))}







            <Col>
              <div className="d-flex flex-lg-row flex-md-row flex-wrap  d-lg-none d-md-block d-block ">
                {AssetsList && AssetsList.length > 0 ? (
                  AssetsList.map((fmd, index) => (
                    <Card
                      className="transparent_card custom_mb w-100 mb-2"
                      key={index}
                      lg="10"
                      md="5"
                      xs="12"
                    >
                      <CardBody className="p-1 p-lg-3">
                        <div className="hover-shadow d-lg-none d-md-block d-block rounded-3 bg-white p-3">
                          <CardTitle className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <div>
                                <span
                                  className="font-weight-bold"
                                  style={{
                                    fontSize: "15px",
                                    color: "#333",
                                    marginLeft: "8px",
                                  }}
                                >
                                  Asset:
                                  <span className="text-success mx-1">
                                    {fmd.asset_name || "N/A"}{" "}
                                  </span>
                                </span>
                              </div>
                              <div className="">
                                <FontAwesomeIcon
                                  className="mx-1"
                                  icon={faPenToSquare}
                                  style={{
                                    color: "orange",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => AddModal(true, fmd)}
                                />
                              </div>
                            </div>
                          </CardTitle>
                          <hr
                            className="mt-0 mb-2"
                            style={{ borderColor: "#FF8C00" }}
                          />

                          <Table className="table mb-0">
                            <tbody>
                              <tr>
                                <th>Asset Category:</th>

                                <td>
                                  {" "}
                                  <span>{fmd.asset_category || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <th>Asset Type:</th>
                                <td>
                                  <span>{fmd.asset_type || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <th>Asset No.:</th>
                                <td>
                                  <span>{fmd.asset_number || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Asset Value:</th>
                                <td>
                                  <span>{fmd.asset_value || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Asset Location:</th>
                                <td>
                                  <span>{fmd.asset_location || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <th>Asset Owner:</th>
                                <td>
                                  <span>{fmd.asset_owner || "N/A"}</span>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  ))
                ) : (
                  <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                    <h5>No Data Available</h5>
                  </div>
                )}
              </div>
            </Col>
          </div>
        </div>
      )}

      <Modal show={showAddModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            {SubmitButtonApi ? "Update" : "Add"} Assets
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-1 p-md-4 p-lg-4">
          <form onSubmit={AddFamilytSubmit}>
            <Row className="text-gray">
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="select"
                  required
                  name="asset_category"
                  value={Group.asset_category}
                  onChange={onInputChange}
                  style={{ padding: "7px" }}
                  className="text-gray"
                >
                  <option value="">Select</option>
                  <option value="movable">Movable</option>

                  <option value="immovable">Immovable</option>
                </CustomTextField>
              </Col>
              <Col lg="4" className="mb-2  ">
                <CustomTextField
                  type="select"
                  required
                  name="asset_type"
                  value={Group.asset_type}
                  onChange={onInputChange}
                  style={{ padding: "8px" }}
                  className="text-gray"
                >
                  <option value="">Select</option>
                  {Group.asset_category === "movable"
                    ? dropdownMovableData.map((item) => {
                        return <option value={item}>{item}</option>;
                      })
                    : Group.asset_category === "immovable"
                    ? dropdownImmMovableData.map((item) => {
                        return <option value={item}>{item}</option>;
                      })
                    : ""}
                </CustomTextField>
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_name"
                  value={Group.asset_name}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_number"
                  value={Group.asset_number}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_value"
                  value={Group.asset_value}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_location"
                  value={Group.asset_location}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="asset_owner"
                  value={Group.asset_owner}
                  onChange={onInputChange}
                />
              </Col>
            </Row>
            <Button
              className={`submit-btn`}
              disabled={disableButton ? true : false}
              style={{ float: "right" }}
              size="sm"
              type="submit"
            >
              Submit &nbsp;
              {disableButton ? <Spinner animation="border" size="sm" /> : ""}
            </Button>

            {showError ? (
              <div style={{ color: "red" }}>
                All The fields are mandatory **
              </div>
            ) : (
              ""
            )}
          </form>
        </Modal.Body>
      </Modal>
    </Card>
  );
};

export default FarmerDetailsAssets;
